import React, { useRef, useEffect } from "react";
import StudentsPlacedChart from "./StudentsPlacedChart";

import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, PieChart, Pie, Cell, LineChart, Line ,LabelList} from "recharts";

const placementData = [
  { year: "2023", value: 280, label: "892+ Placed" },
  { year: "2024", value: 220, label: "1021+ Placed" },
  { year: "2025", value: 280, label: "454+ and growing..." }
];
const placementData1 = [
  { year: "2022", value: 280, label: "2128+ Data Scientist Roles" },
  { year: "2023", value: 220, label: "680+ ML Engineer Roles" },
  { year: "2024", value: 280, label: "280+ and growing..." }
];

const salaryData = [
  { name: "After Course", value: 3 },
  { name: "Remaining", value: 1 }
];

const COLORS = ["#007bff", "#eee"];

const skillData = [
  { month: 1, confidence: 10, label: "Python" },
  { month: 3, confidence: 25, label: "Data Science" },
  { month: 5, confidence: 55, label: "GenAI" },
  { month: 7, confidence: 85, label: "PROJECTS" },
  { month: 8, confidence: 100, label: "PLACEMENT" }
];

const CareerOutcomes = () => {
  const pathRef = useRef(null);

  useEffect(() => {
    const path = pathRef.current;
    if (path) {
      path.style.strokeDasharray = path.getTotalLength();
      path.style.strokeDashoffset = path.getTotalLength();
      setTimeout(() => {
        path.style.transition = "stroke-dashoffset 2s ease";
        path.style.strokeDashoffset = "0";
      }, 100);
    }
  }, []);
  
  return (
    <div className="career-outcomes">
      <h2>Career Outcomes of Our <a href="https://logicmojo.com/best-data-science-courses-for-working-professionals">Data Science Program</a></h2>
      <div className="career-grid">

        {/* Left Column - Bar Chart */}
        <div className="career-card">
          <h3>Placements in Product-Based Companies</h3>
          <StudentsPlacedChart />
          
          <div className="mini-bar-wrapper">
  <h4>Placements in Product-<br />Based Companies</h4>
  <ResponsiveContainer width="100%" height={100}>
    <BarChart layout="vertical" data={placementData1.slice(0, 2)}>
      <XAxis type="number" hide />
      <YAxis type="category" dataKey="year" hide />
      <Bar dataKey="value" fill="#007bff" radius={[10, 10, 10, 10]} barSize={38}>
      <LabelList
                    dataKey="label"
                    position="right"
                    content={({ x, y, value, index }) => (
                      <text
                        x={x + 10}
                        y={y + 26}
                        fill={index === 2 ? "#ffffff" : "#ffffff"}
                        fontSize="16"
                        fontWeight={index === 2 ? "700" : "600"}
                      >
                        {value}
                      </text>
                    )}
              />
              </Bar>
    </BarChart>
  </ResponsiveContainer>
</div>
        </div>

        {/* Middle Column - Pie Chart */}
        <div className="career-card">
          <h3>Average Salary Growth After the Course</h3>
          <div className="salary-chart">
          <ResponsiveContainer width={250} height={250}>
      <PieChart>
        <Pie
          data={salaryData}
          cx="50%"
          cy="50%"
          startAngle={90}
          endAngle={-270}
          innerRadius={70}  // Increased inner radius
          outerRadius={100}  // Increased outer radius
          dataKey="value"
          cornerRadius={10}
        >
          {salaryData.map((entry, index) => (
            <Cell 
              key={`cell-${index}`} 
              fill={COLORS[index % COLORS.length]} 
              stroke="none"  // Remove stroke
            />
          ))}
        </Pie>
      </PieChart>
    </ResponsiveContainer>
    <div className="center-text">
      <div className="salary-amount">1,2 LPA</div>
    </div>
    <div className="growth-label">
      <div className="growth-value">2.5x</div>
      <div className="growth-text">Growth</div>
    </div>
<div className="arrow-icon"></div>

          </div>

          <div className="salary-details">
            <div><span>Before Course</span><span className="tag">₹ 10.2 LPA</span></div>
            <div><span>After Course</span><span className="tag tag-green">₹ 24.5 LPA</span></div>
          </div>
          <div className="companies">
            <img src="assets/images/companyLogo/Microsoft-Logo.wine.svg" alt="Microsoft" />
            <img src="assets/images/companyLogo/Adobe_Inc.-Logo.wine.svg" alt="Adobe" />
            <img src="assets/images/companyLogo/PayPal-Logo.wine.svg" alt="PayPal" />
          </div>
        </div>

        {/* Right Column - Line Chart */}
        <div className="career-card">
          <h3>Skill Confidence Progression by Month</h3>
          <ResponsiveContainer width="100%" height={200}>
  <LineChart data={skillData}>
    <XAxis dataKey="month" />
    <YAxis />
    <Tooltip />
    <Line
      type="monotone"
      dataKey="confidence"
      stroke="#007bff"
      strokeWidth={3}
      dot={{ r: 5 }}
    >
     <LabelList
  dataKey="label"
  position="top"
  style={{ fill: "#000", fontSize: 14 }}
  offset={10} // can help with edge positioning
/>
    </Line>
  </LineChart>
</ResponsiveContainer>

<div className="skill-icons">
  <div className="icon-block">
    <img src="assets/images/icons/preparation.png" alt="Python & SQL" />
    <p>Preparation</p>
  </div>
  <div className="icon-block">
    <img src="assets/images/icons/project1Work.png" alt="Resume" />
    <p>Project Work</p>
  </div>
  <div className="icon-block">
    <img src="assets/images/icons/jobSelection.png" alt="Placement" />
    <p>Job Selection</p>
  </div>
</div>

        </div>
      </div>
    </div>
  );
};

export default CareerOutcomes;
